import { API_BASE_PATH } from '@aibees/shared/constants';

export const INTEGRATION_API_PREFIX = `${API_BASE_PATH}/um/workspaces/:wid/integrations`;
